import React, { Component } from 'react';
import Channel from 'components/helpers/Channel';
import moment from 'moment';

import { connect } from 'react-redux';
import { Row, Col } from 'reactstrap';
import ConfirmationModal from 'components/modals/ConfirmationModal';

import ReactMoment from 'react-moment';
import Table from 'components/table';
import SvgRender from 'components/helpers/SvgRender';
import Filters from './Filters';

import channel from 'assets/svg/channels.svg';
import email from 'assets/svg/email.svg';

import PrivateHeader from 'components/layouts/PrivateHeader';
import { optionsUntrustDevice } from 'utils/alerts';

import {
  fetchChannels,
  fetchActivities,
  fetchIntegrations,
  updateChannelEmail,
  updateChannelDevice,
  unTrustDevice
} from './_actions';

class Channels extends Component {
  fetchActivities = options => {
    const { page, sort_by, search, from, to, integrations } = options;
    const { activities } = this.props;

    const params = {
      page: page ? page : activities.page,
      search: search !== null && search !== undefined ? search : activities.search,
      from: from ? from : activities.from,
      to: to ? to : activities.to,
      sort_by: sort_by ? sort_by : activities.sort_by,
      sort_order: sort_by
        ? activities.sort_order === 'asc' && sort_by === sort_by
          ? 'desc'
          : 'asc'
        : activities.sort_order,
      integrations: integrations ? integrations : activities.integrations
    };

    this.props.fetchActivities(params);
  };

  onEmailUpdate = formValues => {
    this.props.updateChannelEmail(formValues);
  };

  onDeviceUpdate = formValues => {
    this.props.updateChannelDevice(formValues);
  };

  intergrationOnChange = options => {
    this.fetchActivities({
      page: 1,
      integrations: options.map(opt => opt.value)
    });
  };

  onDatesChange = dates => {
    this.fetchActivities({
      page: 1,
      from: dates.from,
      to: moment(dates.to)
        .add('day', 1)
        .format('YYYY-MM-DD')
    });
  };

  onUntrust = id => {
    this.untrustModal.toggle(id, optionsUntrustDevice);
  };

  handleUntrust = id => {
    if (id) {
      this.props.unTrustDevice({ id });
    }
  };
  componentDidMount() {
    this.fetchActivities({ page: 1 });
    this.props.fetchChannels();
    this.props.fetchIntegrations();
  }

  renderActivities = () => {
    const { integrations, activities } = this.props;

    return (
      <Row className="table-wraper mt-2">
        <Col className="col-12">
          <Table
            extra={
              <Filters
                intergrationOnChange={this.intergrationOnChange}
                integrations={integrations}
                onChange={this.onDatesChange}
                dates={{ from: activities.from, to: activities.to }}
              />
            }
            searchPlaceholder="Find a user, intergrations"
            headers={[
              { name: 'Application', label: 'integration_id', sort: true },
              { name: 'Channel' },
              { name: 'Directive' },
              { name: 'Mode' },
              { name: 'Location' },
              { name: 'Time Stamp', label: 'created_at', sort: true },
              { name: 'System' }
            ]}
            columnWidths={[, , , , , 'col-3']}
            rows={activities.data.map(activity => [
              activity.integration.name,
              <div className="justify-content-center">
                <SvgRender
                  path={activity.code && activity.code.code_type === 'scan' ? channel : email}
                  style={{ width: 25 }}
                />
              </div>,
              activity.directive_type,
              activity.code ? activity.code.code_type : '',
              <div>
                {activity.client && activity.client.geo
                  ? `${activity.client.geo.city} ${activity.client.geo.country}`
                  : ''}
              </div>,
              <div className="time-stamp">
                <ReactMoment date={activity.created_at} format="DD-MM-YYYY" />
                <span className="ml-2 mr-2" />
                <ReactMoment date={activity.created_at} format="hh:mm A" />
              </div>,
              <div>
                {activity.client
                  ? `${activity.client.os ? activity.client.os.name : ''} ${
                      activity.client.browser ? activity.client.browser.name : ''
                    }`
                  : ''}
              </div>
            ])}
            defaultSort={{ sort_order: activities.sort_order, sort_by: activities.sort_by }}
            onSort={label => this.fetchActivities({ sort_by: label })}
            search={true}
            onSearch={search => this.fetchActivities({ page: 1, search })}
            pagination={{
              total: activities.total,
              current_page: activities.page,
              last_page: activities.total_pages
            }}
            onPageChange={page => this.fetchActivities({ page })}
          />
        </Col>
      </Row>
    );
  };

  render() {
    const { channels, activities } = this.props;

    return (
      <div className="dash-wrapper">
        <PrivateHeader title="Identity Channels" />

        <div className="box-container pt-10 d-flex">
          {channels &&
            channels.emails.map((email, index) => (
              <Channel onUpdate={this.onEmailUpdate} key={index} type="email" channel={email} />
            ))}
          {channels &&
            channels.devices.map((device, index) => (
              <Channel
                key={index}
                onUpdate={this.onDeviceUpdate}
                type="device"
                onUntrust={this.onUntrust}
                channel={device}
                device={true}
              />
            ))}
        </div>
        {activities && this.renderActivities()}

        <ConfirmationModal ref={el => (this.untrustModal = el)} onChange={this.handleUntrust} />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return state.channels;
}

export default connect(
  mapStateToProps,
  {
    fetchChannels,
    fetchActivities,
    fetchIntegrations,
    updateChannelEmail,
    updateChannelDevice,
    unTrustDevice
  }
)(Channels);



// WEBPACK FOOTER //
// ./src/views/channels/index.js